import { IStyle, mergeStyles } from "@fluentui/react";
import React from "react";


const scrollWrapperStyles: React.CSSProperties = {
    overflowY: "hidden",    //prevents appearance of second vertical scrollbar in parent components
}

/**
 * Outer container centers the inner container both vertically and horizontally.
 */
const outerContainerStyles: IStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around", //does not cropp paddings of it's content (when vertical scrollbar appears)
    alignItems: "center",
    height: "100dvh",
    overflowY: "auto",
};

const baseContainerStyles: IStyle = {
    display: "flex",
    alignItems: "center",
    padding: "64px 144px",
    borderRadius: "20px",
};

const mobileContainerStyles: IStyle = {
    boxShadow: "none",
    padding: "32px 0",   //would allow icon width 280px to fit screen-width with no horizontal scrollbars
    textAlign: "center",
    flexWrap: "wrap",
    flexShrink: "0",    //otherwise would cut bottom padding
    maxWidth: "85%",
    marginLeft: 'auto',     //horizontal align
    marginRight: 'auto',    //horizontal align
    minHeight: "399px",
    gap: "60px",
    '@media (max-height: 480px)': {
        gap: "10px",
        padding: 0,
        minHeight: "auto",
    }
};

const desktopContainerStyles: IStyle = {
    maxWidth: "1092px",
    boxShadow: "0px 0px 22px 0px #7673FB26",
    padding: "64px 144px",
    flexWrap: "nowrap",
    minHeight: "399px",
    gap: "60px",
};

const iconContainerStyles: React.CSSProperties = {
    flex: "1 1 auto",
    minWidth: "200px",
};

const textContainerStyles: React.CSSProperties = {
    fontFamily: "Roboto",
    letterSpacing: "4%",
    fontSize: "20px",
    lineHeight: "1.2em",
    flex: "1 1 auto",
    minWidth: "200px",
};

const titleStyles: React.CSSProperties = {
    fontWeight: 700,
    fontSize: "28px",
    lineHeight: "25px",
    color: "#7673FB",
}



interface ErrorPageWrapperProps {
    icon: React.ReactNode;
    title?: string;
    content: React.ReactNode;
}


export const ErrorPageWrapper: React.FC<ErrorPageWrapperProps> = ({ icon, title, content }) => {
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 1024px)");
        const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);

        // Initial Check
        setIsMobile(mediaQuery.matches);

        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);


    const containerStyles = {
        ...baseContainerStyles,
        ...(isMobile ? mobileContainerStyles : desktopContainerStyles),
    };

    return (
        <div style={scrollWrapperStyles}>
            <div className={mergeStyles(outerContainerStyles)}>
                <div className={mergeStyles(containerStyles)}>
                    <div style={iconContainerStyles}>{icon}</div>
                    <div style={textContainerStyles}>
                        {title && <h1 style={titleStyles}>{title}</h1>}
                        <div>{content}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
